import { useEffect, useRef, useState } from "react";

// Typing animation component for placeholder text
const useTypingAnimation = (texts: string[], typingSpeed = 50, deletingSpeed = 20, pauseTime = 1000) => {
	const [displayText, setDisplayText] = useState("");
	const [currentIndex, setCurrentIndex] = useState(0);
	const [isDeleting, setIsDeleting] = useState(false);
	const pauseTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

	const currentText = texts[currentIndex];

	useEffect(() => {
		const timer = setTimeout(
			() => {
				if (!isDeleting) {
					if (displayText.length < currentText.length) {
						setDisplayText(currentText.slice(0, displayText.length + 1));
					} else {
						// Clear any existing pause timer before creating a new one
						if (pauseTimerRef.current) {
							clearTimeout(pauseTimerRef.current);
						}
						pauseTimerRef.current = setTimeout(() => setIsDeleting(true), pauseTime);
					}
				} else if (displayText.length > 0) {
					setDisplayText(displayText.slice(0, -1));
				} else {
					setIsDeleting(false);
					setCurrentIndex(prev => (prev + 1) % texts.length);
				}
			},
			isDeleting ? deletingSpeed : typingSpeed,
		);

		return () => {
			clearTimeout(timer);
			if (pauseTimerRef.current) {
				clearTimeout(pauseTimerRef.current);
				pauseTimerRef.current = null;
			}
		};
	}, [displayText, currentText, isDeleting, texts.length, typingSpeed, deletingSpeed, pauseTime]);

	return displayText;
};

export default useTypingAnimation;
